import { getString } from "../../common/common";

export const TAB5_HEADING1 = "TAB5_HEADING1";
export const TAB5_HEADING2 = "TAB5_HEADING2";
export const TAB5_LI1 = "TAB5_LI1";
export const TAB5_LI2 = "TAB5_LI2";
export const TAB5_LI3 = "TAB5_LI3";
export const TAB5_LI4 = "TAB5_LI4";
export const TAB5_LI5 = "TAB5_LI5";
export const TAB5_LI6 = "TAB5_LI6";
export const TAB5_LI7 = "TAB5_LI7";
export const TAB5_LI8 = "TAB5_LI8";

export const translations = {
  en: {
    [TAB5_HEADING1]: "Airavat",
    [TAB5_HEADING2]: "The silent features of Airavat are as follows:",
    [TAB5_LI1]:
      "Full Air Suspension on all four wheels for comfortable journey.",
    [TAB5_LI1]:
      "Full Air Suspension on all four wheels for comfortable journey.",
    [TAB5_LI2]:
      "45 Ergonomically designed Executive Passenger Seats, Luxurious and Comfortable reclining seats.",
    [TAB5_LI3]:
      "Four Emergency Exits and one Emergency Door provided on right hand side of the bus for more safety to passengers.",
    [TAB5_LI4]:
      "Light Green Tinted Toughened Glasses provided for clear vision.",
    [TAB5_LI5]:
      "Front panel design modified to increase the driver vision area and aesthetic look of the bus.",
    [TAB5_LI6]: "10 Cu mt luggage space under the passenger seating area.",
    [TAB5_LI7]: "Computerized Speed control.",
    [TAB5_LI8]: "CRDI Ignition system",
  },
  kn: {
    [TAB5_HEADING1]: "ಐರಾವತ",
    [TAB5_HEADING2]: "ಐರಾವತದ ವಿಶೇಷ ಲಕ್ಷಣಗಳು ಹೀಗಿವೆ:",
    [TAB5_LI1]:
      "ಆರಾಮದಾಯಕ ಪ್ರಯಾಣಕ್ಕಾಗಿ ಎಲ್ಲಾ ನಾಲ್ಕು ಚಕ್ರಗಳಲ್ಲಿ ಸಂಪೂರ್ಣ ಏರ್ ಸಸ್ಪೆನ್ಷನ್.",
    [TAB5_LI1]:
      "ಆರಾಮದಾಯಕ ಪ್ರಯಾಣಕ್ಕಾಗಿ ಎಲ್ಲಾ ನಾಲ್ಕು ಚಕ್ರಗಳಲ್ಲಿ ಸಂಪೂರ್ಣ ಏರ್ ಸಸ್ಪೆನ್ಷನ್.",
    [TAB5_LI2]:
      "45 ದಕ್ಷತಾಶಾಸ್ತ್ರದ ವಿನ್ಯಾಸದ ಕಾರ್ಯನಿರ್ವಾಹಕ ಪ್ರಯಾಣಿಕರ ಆಸನಗಳು, ಐಷಾರಾಮಿ ಮತ್ತು ಆರಾಮದಾಯಕವಾದ ಒರಗಿಕೊಳ್ಳುವ ಆಸನಗಳು.",
    [TAB5_LI3]:
      "ಪ್ರಯಾಣಿಕರಿಗೆ ಹೆಚ್ಚಿನ ಸುರಕ್ಷತೆಗಾಗಿ ಬಸ್ಸಿನ ಬಲಭಾಗದಲ್ಲಿ ನಾಲ್ಕು ತುರ್ತು ನಿರ್ಗಮನಗಳು ಮತ್ತು ಒಂದು ತುರ್ತು ಬಾಗಿಲು ನೀಡಲಾಗಿದೆ .",
    [TAB5_LI4]:
      "ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣಲು  ತಿಳಿ ಹಸಿರು ಬಣ್ಣದ ಟಫ್ ಗ್ಲಾಸ್‌ಗಳನ್ನು ನೀಡಲಾಗಿದೆ.",
    [TAB5_LI5]:
      "ಚಾಲಕಕನಿಗೆ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣಲು ಮತ್ತು ಬಸ್‌ನ ಸೌಂದರ್ಯದ ನೋಟವನ್ನು ಹೆಚ್ಚಿಸಲು ಮುಂಭಾಗದ ಫಲಕ ವಿನ್ಯಾಸವನ್ನು ಮಾರ್ಪಡಿಸಲಾಗಿದೆ.",
    [TAB5_LI6]: "ಪ್ರಯಾಣಿಕರ ಸೀಟ್ ನ ಜಾಗದ ಅಡಿಯಲ್ಲಿ 10 Cu mt ಲಗೇಜ್ ಸ್ಥಳ ನೀಡಲಾಗಿದೆ.",
    [TAB5_LI7]: "ಗಣಕೀಕೃತ ವೇಗ ನಿಯಂತ್ರಣ.",
    [TAB5_LI8]: "CRDI ಇಗ್ನಿಷನ್  ವ್ಯವಸ್ಥೆ.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
